interface RiskPostureScoreProps {
  score: number | null;
  max: number | null;
  className?: string;
}

export const RiskPostureScore = ({ score, max, className = '' }: RiskPostureScoreProps) => {
  if (score === null || max === null) {
    return (
      <div className={`flex flex-col gap-2 ${className}`} role="group" aria-label="Risk Posture Score">
        <h3 className="font-['Inter'] font-medium text-sm leading-5 text-[#0F172B]">
          Risk Posture Score
        </h3>
        <div className="font-['Inter'] font-semibold text-xl leading-7 text-gray-400">N/A</div>
      </div>
    );
  }

  const percentage = max > 0 ? Math.round((score / max) * 100) : 0;

  return (
    <div className={`flex flex-col gap-2 ${className}`} role="group" aria-label="Risk Posture Score">
      <h3 className="font-['Inter'] font-medium text-sm leading-5 text-[#0F172B]">
        Risk Posture Score
      </h3>
      <div className="flex flex-col gap-2">
        <div className="flex flex-row items-baseline gap-2">
          <span className="font-['Inter'] font-semibold text-xl leading-7 text-[#0F172B]">{score}</span>
          <span className="font-['Inter'] font-medium text-base leading-6 text-[#90A1B9]">/ {max}</span>
        </div>
        <div
          className="h-1 w-full bg-[#E2E8F0] rounded-lg overflow-hidden relative"
          role="progressbar"
          aria-valuenow={score}
          aria-valuemin={0}
          aria-valuemax={max}
        >
          <div
            className="absolute left-0 top-0 h-full bg-[#006FEE] rounded-lg"
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
    </div>
  );
};
